// extracted by mini-css-extract-plugin
var _1 = "webpack-components-shared-SkipLinks-SkipLinks-module__container";
var _2 = "webpack-components-shared-SkipLinks-SkipLinks-module__list";
var _3 = "webpack-components-shared-SkipLinks-SkipLinks-module__wrapper";
export { _1 as "container", _2 as "list", _3 as "wrapper" }
